/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import { stepEnumOfAccordion } from '../../Constants';
import Files from '../../Files/Files';
import ServiceForm from '../ServiceForm';
import ProviderServiceRequestContainer from '../../../ProvidersForm/ProviderServiceRequestContainer';
import AssociatedUsersContainer from '../../AssociatedUsersForm/AssociatedUsersContainer';

// requestField: Se utiliza para acceder en forma de texto a ese accordion en especifico
// esto es porque en los setFieldValue('', valor) de formik, debemos accederlo con el texto
// requestValue: Se utiliza para acceder al valor de ese accordion en especifico
const BodyAccordion = ({
  isApplyTemplateRequest,
  accordionIndex,
  accordionOpen,
  notificationOptions,
  handleServiceCompleted,
  isAutocomplete,
  backToUbicationForm,
  disabledAllFields
}) => {
  const { values, setFieldValue, setFieldTouched, errors, touched } = useFormikContext();
  const requestField = `accordions[${accordionIndex}]`;
  const requestValue = values?.accordions[accordionIndex];
  const requestErrors = errors?.accordions ? errors?.accordions[accordionIndex] : null;
  const requestTouched = touched?.accordions ? touched?.accordions[accordionIndex] : null;
  const accordionId = `${requestValue?.accordionId}`;

  const currentStep = useMemo(
    () => values?.accordions[accordionIndex]?.accordionStep,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [values?.accordions[accordionIndex]?.accordionStep, accordionIndex]
  );

  const showStep = (step) => step <= currentStep;

  const setStep = (step) => setFieldValue(`accordions[${accordionIndex}].accordionStep`, step);

  const hasErrors = () => {
    if (requestErrors && !isApplyTemplateRequest) {
      return Object.keys(requestErrors).some((key) => requestErrors[key]);
    }

    return false;
  };

  const resetField = async (conditionToTouched, fieldName, resetValue) => {
    if (conditionToTouched) {
      setFieldTouched(fieldName);
    }
    setFieldValue(fieldName, resetValue);
  };

  useEffect(() => {
    handleServiceCompleted(hasErrors());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors, handleServiceCompleted]);

  return (
    accordionOpen && (
      <>
        {showStep(stepEnumOfAccordion.service) && (
          <ServiceForm
            accordionIndex={accordionIndex}
            backToUbicationForm={backToUbicationForm}
            disabledAllFields={disabledAllFields}
            isApplyTemplateRequest={isApplyTemplateRequest}
            requestErrors={requestErrors}
            requestField={requestField}
            requestTouched={requestTouched}
            requestValue={requestValue}
            resetField={resetField}
            setStep={setStep}
            step={currentStep}
          />
        )}
        {showStep(stepEnumOfAccordion.provider) && (
          <ProviderServiceRequestContainer
            accordionIndex={accordionIndex}
            createSDS
            disabledAllFields={disabledAllFields}
            isAutocomplete={isAutocomplete}
            params={{
              notificationOptions
            }}
            requestErrors={requestErrors}
            requestField={requestField}
            requestTouched={requestTouched}
            requestValue={requestValue}
            resetField={resetField}
            setStep={setStep}
            step={currentStep}
          />
        )}
        {showStep(stepEnumOfAccordion.associatedUsers) && (
          <AssociatedUsersContainer
            accordionIndex={accordionIndex}
            disabledAllFields={disabledAllFields}
            imptationObjectWells={values?.imputationObject?.wells}
            isApplyTemplateRequest={isApplyTemplateRequest}
            isDraft={!!requestValue?.serviceRequestId}
            requestErrors={requestErrors}
            requestField={requestField}
            requestTouched={requestTouched}
            requestValue={requestValue}
            serviceId={values?.accordions[accordionIndex].service?.service?.id}
            setStep={setStep}
            step={currentStep}
            ubicationTeamValue={values?.ubication?.team?.value}
            ubicationTypeId={values?.ubication?.ubicationType?.id}
          />
        )}
        {showStep(stepEnumOfAccordion.files) && (
          <Files
            accordionId={accordionId}
            disabledAllFields={disabledAllFields}
            requestField={requestField}
            serviceRequestId={requestValue?.serviceRequestId}
            step={currentStep}
            templateRequestId={requestValue?.templeteRequestId}
          />
        )}
      </>
    )
  );
};

BodyAccordion.propTypes = {
  isAutocomplete: PropTypes.bool,
  isApplyTemplateRequest: PropTypes.bool,
  disabledAllFields: PropTypes.bool,
  accordionIndex: PropTypes.number.isRequired,
  accordionOpen: PropTypes.bool.isRequired,
  handleServiceCompleted: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  notificationOptions: PropTypes.array.isRequired,
  backToUbicationForm: PropTypes.func.isRequired
};

BodyAccordion.defaultProps = {
  isApplyTemplateRequest: false,
  disabledAllFields: false,
  isAutocomplete: false
};
export default BodyAccordion;
